export default "__VITE_ASSET__CMr5Xfgu__"